import styles from './Footer.module.css';
import { site } from '../content/site.js';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      {site.footer.map((f, i) => <p key={i}>{f}</p>)}
    </footer>
  );
}
